export const FETCH_ADMIN_ALERT_SUCCESS = 'FETCH_ADMIN_ALERT_SUCCESS';

export function fetchAdminAlertSuccess(res) {
  return {
    type: FETCH_ADMIN_ALERT_SUCCESS,
    payload: {
      text: res,
    },
  };
}



// WEBPACK FOOTER //
// ./src/actions/adminAlert.js